import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {TemplateLogItem} from '../../../creativeTemplateActivityLog.types';
import {CreativeTemplateHomeTabState} from './creativeTemplateHomeTab.types';

const creativeTemplateHomeTabInitialState: CreativeTemplateHomeTabState = {
  activityLogs: [],
};

const creativeTemplateHomeTabReducer = createSlice({
  name: BreadcrumbName.CreativeTemplateHomeTab,
  initialState: creativeTemplateHomeTabInitialState,
  reducers: {
    resetState: () => creativeTemplateHomeTabInitialState,
    setActivityLogs: (state, action: PayloadAction<TemplateLogItem[]>) => {
      state.activityLogs = action.payload;
    },
  },
});

export const {resetState, setActivityLogs} = creativeTemplateHomeTabReducer.actions;

export default creativeTemplateHomeTabReducer.reducer;
